export const columns = [
  {
    field: "tracking_code",
    headerName: "CÓDIGO DE RESTREO",
    width: 180,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>CÓDIGO DE RASTREO</strong>,
  },
  {
    field: "recipient_name",
    headerName: "NOMBRE DEL DESTINATARIO",
    minWidth: 200,
    flex: 1,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>NOMBRE DEL DESTINATARIO</strong>,
  },
  {
    field: "payment_method",
    headerName: "MÉTODO PAGO",
    minWidth: 200,
    flex: 1,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>MÉTODO PAGO</strong>,
  },
  {
    field: "amount",
    headerName: "CANTIDAD PAGO",
    minWidth: 200,
    flex: 1,
    resizable: false,
    sortable: false,
    renderHeader: (params) => <strong>CANTIDAD PAGO</strong>,
  },
];